import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Button, makeStyles } from '@material-ui/core'
import React from 'react'
import { SPEC_INT_NAVY_COLOR, SPEC_INT_NEUTRAL_GRAY_COLOR } from '../../specIntelligenceConstants'

const useStyles = makeStyles(() => ({
    actions: {
        display: 'flex',
        gap: pxToRem(8),
        marginTop: pxToRem(10),
    },
    resolveButton: {
        flex: 1,
        textTransform: 'none' as const,
        fontSize: pxToRem(12),
        fontWeight: 500,
        backgroundColor: SPEC_INT_NAVY_COLOR,
        color: '#FFFFFF',
        '&:hover': { backgroundColor: '#02264A' },
    },
    dismissButton: {
        flex: 1,
        textTransform: 'none' as const,
        fontSize: pxToRem(12),
        fontWeight: 500,
        borderColor: SPEC_INT_NEUTRAL_GRAY_COLOR,
        color: '#424242',
    },
}))

export interface FindingCardActionsProps {
    findingId: string
    onResolve: (id: string) => void
    onDismiss: (id: string) => void
}

/** Resolve/Dismiss buttons for an expanded finding card. Stops click/keydown propagation so they don't toggle the card's expansion. */
const FindingCardActions = ({ findingId, onResolve, onDismiss }: FindingCardActionsProps) => {
    const classes = useStyles()
    return (
        <div
            className={classes.actions}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.stopPropagation() }}
        >
            <Button
                variant="contained"
                size="small"
                className={classes.resolveButton}
                onClick={() => onResolve(findingId)}
                disableElevation
                data-testid="resolveButton"
            >
                Resolve
            </Button>
            <Button
                variant="outlined"
                size="small"
                className={classes.dismissButton}
                onClick={() => onDismiss(findingId)}
                data-testid="dismissButton"
            >
                Dismiss
            </Button>
        </div>
    )
}

export default FindingCardActions
